export const isNumber = (n: any): n is number => typeof n === 'number' && !isNaN(n) && !isNaN(n % 1)
export const isInteger = (n: any): n is number => isNumber(n) && n % 1 === 0

// WARNING: this method will return a new int value on every call, breaking strict equality
export const ensureInt = (n: any): number | null => isNaN(n) ? null : parseInt(n, 10)
